// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Core Container --- */
.dashboard-modal {
  background: #ffffff;
  max-width: 860px;
  margin: 40px auto;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
  font-family: 'Segoe UI', sans-serif;
}

/* --- Title --- */
.dashboard-title {
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.dashboard-title i {
  font-size: 22px;
  color: #007bff;
}

/* --- User Info --- */
.user-info-box {
  background: #f4f8fb;
  padding: 18px 24px;
  border-left: 4px solid #007bff;
  border-radius: 10px;
  margin-bottom: 30px;
}
.user-info-box p {
  margin: 6px 0;
  font-size: 15px;
  color: #333;
}

/* --- Section Titles --- */
.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #444;
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-title i {
  font-size: 16px;
  color: #555;
}

/* --- Action Buttons --- */
.referral-action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}
.share-referral-btn,
.copy-referral-btn {
  padding: 10px 22px;
  font-size: 15px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.25s ease-in-out;
  max-width: 280px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.share-referral-btn {
  background-color: #007bff;
  color: white;
}
.share-referral-btn:hover {
  background-color: #0056b3;
}
.copy-referral-btn {
  background-color: #4a5568;
  color: white;
}
.copy-referral-btn:hover {
  background-color: #2d3748;
}

/* --- Encouragement Message --- */
.referrals-exist-message {
  background-color: #f4f8fb;
  padding: 20px;
  border-left: 4px solid #28a745;
  border-radius: 10px;
  margin-bottom: 30px;
  text-align: center;
}
.referrals-exist-text {
  font-size: 16px;
  color: #333;
  margin: 0;
}

/* --- No Referrals UI --- */
.no-referrals-box {
  background-color: #fdfdfd;
  border-radius: 14px;
  padding: 28px;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
  margin-top: 35px;
}
.no-referrals-text {
  font-size: 16px;
  color: #444;
  margin-bottom: 22px;
  line-height: 1.7;
}
.no-referrals {
  text-align: center;
  font-style: italic;
  color: #888;
}

/* --- Referral Table (Shared) --- */
.referral-table {
  margin-top: 20px;
}
.referral-table table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.referral-table th,
.referral-table td {
  padding: 12px 16px;
  font-size: 14px;
  text-align: left;
  border-bottom: 1px solid #eee;
}
.referral-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.referral-table tr:last-child td {
  border-bottom: none;
}

/* --- Responsive Table for Mobile --- */
@media (max-width: 600px) {
  .dashboard-modal {
    margin: 20px;
    padding: 24px;
  }
  .referral-table table,
  .referral-table thead,
  .referral-table tbody,
  .referral-table th,
  .referral-table td,
  .referral-table tr {
    display: block;
  }
  .referral-table th {
    display: none;
  }
  .referral-table td {
    position: relative;
    padding: 12px 16px;
    padding-left: 55%;
    margin-bottom: 15px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  }
  .referral-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 600;
    color: #333;
    white-space: nowrap;
  }
  .referral-action-buttons {
    width: 100%;
  }
}

/* --- Copied Toast --- */
.copied-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #d4edda;
  color: #155724;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  z-index: 9999;
  animation: fadeInOut 3s ease-in-out;
  border: 1px solid #c3e6cb;
}
@keyframes fadeInOut {
  0% { opacity: 0; transform: translate(-50%, -20px); }
  10% { opacity: 1; transform: translate(-50%, 0); }
  90% { opacity: 1; transform: translate(-50%, 0); }
  100% { opacity: 0; transform: translate(-50%, -10px); }
}

/* Fix: Ensure referral-leads-table renders correctly on desktop */
.referral-leads-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
}

.referral-leads-table th,
.referral-leads-table td {
  padding: 12px 16px;
  font-size: 14px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.referral-leads-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.referral-leads-table tr:last-child td {
  border-bottom: none;
}

/* Responsive override for mobile layout */
@media (max-width: 600px) {
  .referral-leads-table,
  .referral-leads-table thead,
  .referral-leads-table tbody,
  .referral-leads-table th,
  .referral-leads-table td,
  .referral-leads-table tr {
    display: block;
  }

  .referral-leads-table th {
    display: none;
  }

  .referral-leads-table td {
    position: relative;
    padding-left: 50%;
    text-align: left;
    margin-bottom: 12px;
    border: 1px solid #eee;
    border-radius: 8px;
    background-color: #fff;
  }

  .referral-leads-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-weight: bold;
    color: #333;
  }
}

.referral-subtitle {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-top: 30px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;;;;;;IAME,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,KAAK,UAAU,EAAE,iCAAiC,EAAE;EACpD,MAAM,UAAU,EAAE,6BAA6B,EAAE;EACjD,MAAM,UAAU,EAAE,6BAA6B,EAAE;EACjD,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":["@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css');\n\n/* --- Core Container --- */\n.dashboard-modal {\n  background: #ffffff;\n  max-width: 860px;\n  margin: 40px auto;\n  padding: 40px;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);\n  font-family: 'Segoe UI', sans-serif;\n}\n\n/* --- Title --- */\n.dashboard-title {\n  text-align: center;\n  font-size: 26px;\n  font-weight: 600;\n  margin-bottom: 30px;\n  color: #222;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.dashboard-title i {\n  font-size: 22px;\n  color: #007bff;\n}\n\n/* --- User Info --- */\n.user-info-box {\n  background: #f4f8fb;\n  padding: 18px 24px;\n  border-left: 4px solid #007bff;\n  border-radius: 10px;\n  margin-bottom: 30px;\n}\n.user-info-box p {\n  margin: 6px 0;\n  font-size: 15px;\n  color: #333;\n}\n\n/* --- Section Titles --- */\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #444;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.section-title i {\n  font-size: 16px;\n  color: #555;\n}\n\n/* --- Action Buttons --- */\n.referral-action-buttons {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n}\n.share-referral-btn,\n.copy-referral-btn {\n  padding: 10px 22px;\n  font-size: 15px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.25s ease-in-out;\n  max-width: 280px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.share-referral-btn {\n  background-color: #007bff;\n  color: white;\n}\n.share-referral-btn:hover {\n  background-color: #0056b3;\n}\n.copy-referral-btn {\n  background-color: #4a5568;\n  color: white;\n}\n.copy-referral-btn:hover {\n  background-color: #2d3748;\n}\n\n/* --- Encouragement Message --- */\n.referrals-exist-message {\n  background-color: #f4f8fb;\n  padding: 20px;\n  border-left: 4px solid #28a745;\n  border-radius: 10px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n.referrals-exist-text {\n  font-size: 16px;\n  color: #333;\n  margin: 0;\n}\n\n/* --- No Referrals UI --- */\n.no-referrals-box {\n  background-color: #fdfdfd;\n  border-radius: 14px;\n  padding: 28px;\n  text-align: center;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);\n  margin-top: 35px;\n}\n.no-referrals-text {\n  font-size: 16px;\n  color: #444;\n  margin-bottom: 22px;\n  line-height: 1.7;\n}\n.no-referrals {\n  text-align: center;\n  font-style: italic;\n  color: #888;\n}\n\n/* --- Referral Table (Shared) --- */\n.referral-table {\n  margin-top: 20px;\n}\n.referral-table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  background-color: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.referral-table th,\n.referral-table td {\n  padding: 12px 16px;\n  font-size: 14px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n.referral-table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n}\n.referral-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* --- Responsive Table for Mobile --- */\n@media (max-width: 600px) {\n  .dashboard-modal {\n    margin: 20px;\n    padding: 24px;\n  }\n  .referral-table table,\n  .referral-table thead,\n  .referral-table tbody,\n  .referral-table th,\n  .referral-table td,\n  .referral-table tr {\n    display: block;\n  }\n  .referral-table th {\n    display: none;\n  }\n  .referral-table td {\n    position: relative;\n    padding: 12px 16px;\n    padding-left: 55%;\n    margin-bottom: 15px;\n    text-align: left;\n    background-color: #fff;\n    border: 1px solid #eee;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(0,0,0,0.04);\n  }\n  .referral-table td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-weight: 600;\n    color: #333;\n    white-space: nowrap;\n  }\n  .referral-action-buttons {\n    width: 100%;\n  }\n}\n\n/* --- Copied Toast --- */\n.copied-toast {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #d4edda;\n  color: #155724;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n  z-index: 9999;\n  animation: fadeInOut 3s ease-in-out;\n  border: 1px solid #c3e6cb;\n}\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translate(-50%, -20px); }\n  10% { opacity: 1; transform: translate(-50%, 0); }\n  90% { opacity: 1; transform: translate(-50%, 0); }\n  100% { opacity: 0; transform: translate(-50%, -10px); }\n}\n\n/* Fix: Ensure referral-leads-table renders correctly on desktop */\n.referral-leads-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 16px;\n}\n\n.referral-leads-table th,\n.referral-leads-table td {\n  padding: 12px 16px;\n  font-size: 14px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.referral-leads-table th {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n}\n\n.referral-leads-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Responsive override for mobile layout */\n@media (max-width: 600px) {\n  .referral-leads-table,\n  .referral-leads-table thead,\n  .referral-leads-table tbody,\n  .referral-leads-table th,\n  .referral-leads-table td,\n  .referral-leads-table tr {\n    display: block;\n  }\n\n  .referral-leads-table th {\n    display: none;\n  }\n\n  .referral-leads-table td {\n    position: relative;\n    padding-left: 50%;\n    text-align: left;\n    margin-bottom: 12px;\n    border: 1px solid #eee;\n    border-radius: 8px;\n    background-color: #fff;\n  }\n\n  .referral-leads-table td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-weight: bold;\n    color: #333;\n  }\n}\n\n.referral-subtitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin-top: 30px;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
